var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92389 0.577571C5.2493 0.903013 5.2493 1.43065 4.92389 1.75609L3.01314 3.66683H7.2513C9.78264 3.66683 11.8346 5.71883 11.8346 8.25016C11.8346 10.7815 9.78264 12.8335 7.2513 12.8335H5.16797C4.70772 12.8335 4.33464 12.4604 4.33464 12.0002C4.33464 11.5399 4.70772 11.1668 5.16797 11.1668H7.2513C8.86213 11.1668 10.168 9.861 10.168 8.25016C10.168 6.63933 8.86213 5.3335 7.2513 5.3335H3.01314L4.92389 7.24425C5.2493 7.56966 5.2493 8.09733 4.92389 8.42275C4.59847 8.74816 4.07082 8.74816 3.74538 8.42275L0.412044 5.08942C0.0866104 4.76398 0.0866104 4.23635 0.412044 3.9109L3.74538 0.577571C4.07082 0.252138 4.59847 0.252138 4.92389 0.577571Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.b25c2f908206b5b4658b5c56d6f6dc1c.svg";
export { ForwardRef as ReactComponent };